import React, { PureComponent } from 'react';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import classNames from 'classnames';

import { BaseInputProps } from '../types';
import { isNullLike } from '../utils';

import { Instruments } from './Instruments';
import { Num } from './Num';

export interface InstrumentValueInfo {
  instrument: string;
  value?: number;
}

export interface InstrumentValueProps extends BaseInputProps {
  value?: InstrumentValueInfo[];

  onChange?: (val: InstrumentValueInfo[]) => void;

  options?: string[];
}

export class InstrumentsValueList extends PureComponent<InstrumentValueProps> {
  value: InstrumentValueInfo[] = [];

  isEmptyItem = (item: InstrumentValueInfo) => {
    return !item.instrument?.trim() && isNullLike(item.value);
  };

  onChange = (i: number, val: any, key?: keyof InstrumentValueInfo) => {
    const value = [...this.value];
    if (!value[i]) value[i] = { instrument: '' };
    if (key) value[i][key] = val as never;
    else value[i] = { ...value[i], ...val };
    this.props.onChange?.(
      value.length === 1 && this.isEmptyItem(value[0]) ? [] : value,
    );
  };

  onAdd = (i: number) => {
    const value = [...this.value];
    value.splice(i + 1, 0, { instrument: '' });
    this.props.onChange?.(value);
    this.props.onBlur?.();
  };

  onDel = (i: number) => {
    const value = [...this.value];
    value.splice(i, 1);
    this.props.onChange?.(
      value.length === 1 && this.isEmptyItem(value[0]) ? [] : value,
    );
    this.props.onBlur?.();
  };

  render() {
    this.value = this.props.value || [];
    // if (!this.value.length && !this.props.readonly)
    //   this.value.push({ instrument: '' });
    return (
      <div
        className={classNames(
          'param-expiries-limit',
          { readonly: this.props.readonly },
          this.props.className,
        )}
        style={this.props.style}
      >
        {this.props.readonly ? (
          this.props.value?.length ? (
            this.value
              .filter(it => it.instrument)
              .map((it, i) => (
                <span className="param-expiries-limit-val" key={i}>
                  {it.instrument}
                  <span className="param-expiries-limit-val-sep">/</span>
                  {!isNullLike(it.value) ? it.value : '-'}
                  <br />
                </span>
              ))
          ) : (
            '-'
          )
        ) : (
          <div className="grid grid-cols-7 gap-7 w-full p-2">
            {/* 表头 */}
            <div className="font-medium text-gray-700 rounded-md col-span-3">Instrument</div>
            <div className="font-medium text-gray-700 rounded-md col-span-2">Value</div>
            <div className="rounded-md"></div>
            {
              this.value?.length > 0 ? <div className="rounded-md"></div> : <div className="flex items-center space-x-2">
              <button
                onClick={() => this.onAdd(0)}
                className="p-1 rounded-full hover:bg-blue-100 transition-colors"
                aria-label="Add item"
              >
                <PlusOutlined className="text-blue-600" />
              </button>
            </div>
            }
            
            {/* 数据行 */}
            {this.value.map((it, i) => (
              <React.Fragment key={i}>
                {/* Instrument列 */}
                <div className="flex items-center col-span-3">
                  <Instruments
                    className="w-full max-w-[15rem]"
                    multiple={false}
                    options={this.props.options}
                    value={[it.instrument]}
                    onChange={val => this.onChange(i, val[0], 'instrument')}
                    calcDisabled={instrument =>
                      this.value.some(
                        item => item !== it && item.instrument === instrument,
                      )
                    }
                    onBlur={this.props.onBlur}
                  />
                </div>
                
                {/* Value列 */}
                <div className="flex items-center col-span-2">
                  <Num
                    className="w-full max-w-[11.25rem] h-8"
                    value={it.value}
                    onChange={val => this.onChange(i, { value: val })}
                    onBlur={this.props.onBlur}
                  />
                </div>
                
                {/* 空列 */}
                <div></div>
                
                {/* 操作列 */}
                <div className="flex items-center space-x-2">
                  <button
                    onClick={() => this.onAdd(i)}
                    className="p-1 rounded-full hover:bg-blue-100 transition-colors"
                    aria-label="Add item"
                  >
                    <PlusOutlined />
                  </button>
                  <button
                    onClick={() => this.onDel(i)}
                    className="p-1 rounded-full hover:bg-red-100 transition-colors"
                    aria-label="Delete item"
                  >
                    <DeleteOutlined />
                  </button>
                </div>
              </React.Fragment>
            ))}
          </div>
        )}
      </div>
    );
  }
}
